/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportScheduleRecurrence {
    getFixupPrototypeFunction() { return ReportScheduleRecurrence.fixupPrototype; }

    static newInstance(model: Partial<ReportScheduleRecurrence>): ReportScheduleRecurrence {
        let obj = Object.assign(new ReportScheduleRecurrence(), model);
        ReportScheduleRecurrence.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportScheduleRecurrence>): ReportScheduleRecurrence {
        if (!model) return null;
        return ReportScheduleRecurrence.newInstance(<ReportScheduleRecurrence> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportScheduleRecurrence) {
        if (!obj) return;

        models.ReportScheduleRecurrence.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportScheduleRecurrence): boolean {
        Object.setPrototypeOf(obj, ReportScheduleRecurrence.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.interval === undefined) {
            this.interval = 0;
        }
    }

    /**
     * How often the schedule runs
     */
    type: models.ReportScheduleRecurrenceType;

    /**
     * Run every N days (daily, 1-31) or every N weeks (weekly, 1-5); ignored by other types
     */
    interval: number;

    /**
     * Days the schedule runs on; used by weekly and monthly_by_week
     */
    days_of_week: Array<models.ReportScheduleDayOfWeek>;

    /**
     * Week of the month the schedule runs in; used by monthly_by_week
     */
    week_of_month: models.ReportScheduleWeekOfMonth;

    /**
     * Dates of the month the schedule runs on; used by monthly_by_date
     */
    days_of_month: Array<number>;

    /**
     * Months the schedule runs in; used by monthly_by_week and monthly_by_date
     */
    months: Array<models.ReportScheduleMonth>;

}
